<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">add_link</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Vincular a oportunidade existente</h2>
    <span class="modal-subtitle">{{ subtitulo }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" [disabled]="isVinculando"
      (click)="fechar()" matTooltip="Fechar" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (isLoading) {
    <app-loading-box-default-list></app-loading-box-default-list>
  } @else if (oportunidades.length === 0) {
    <app-empty-state icon="forum" title="Nenhuma oportunidade aberta"
      subtitle='Este cliente não tem oportunidade aberta no seu escopo. Use "Criar oportunidade".'>
    </app-empty-state>
  } @else {
    <p class="vod-descricao">Oportunidades abertas de {{ data.nomeCliente }}, dentro do seu escopo.</p>

    <mat-radio-group class="vod-lista" aria-label="Oportunidade" [(ngModel)]="idOportunidadeSelecionada"
      [disabled]="isVinculando">
      @for (oportunidade of oportunidades; track oportunidade.idOportunidade) {
        <app-action-card [interactive]="true" [selected]="idOportunidadeSelecionada === oportunidade.idOportunidade"
          [disabled]="isVinculando" (click)="selecionar(oportunidade)">
          <mat-radio-button actionCardIcon [value]="oportunidade.idOportunidade"
            [attr.aria-label]="'Oportunidade #' + oportunidade.codigo"></mat-radio-button>
          <div class="vod-linha">
            <span class="vod-codigo">#{{ oportunidade.codigo }}</span>
            <span class="vod-textos">
              <span class="vod-titulo">{{ oportunidade.titulo }}</span>
              <small class="text-muted">{{ oportunidade.nomeVendedor }}</small>
            </span>
          </div>
          <span cardActions class="status-badge badge-cinza">{{ oportunidade.nomeEtapa }}</span>
        </app-action-card>
      }
    </mat-radio-group>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isVinculando" (click)="fechar()">
    Cancelar
  </button>
  <span [matTooltip]="'Escolha uma oportunidade para vincular.'" [matTooltipDisabled]="idOportunidadeSelecionada != null || isVinculando">
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isVinculando"
      [disabled]="idOportunidadeSelecionada == null || isVinculando"
      [attr.aria-label]="isVinculando ? 'Vinculando' : 'Vincular'" (click)="vincular()">
      <mat-icon class="material-symbols-outlined">add_link</mat-icon>
      Vincular
      @if (isVinculando) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
  </span>
</mat-dialog-actions>
